import { UrlParams } from '../models/piece-html-container-settings';

export class HtmlContainerHelper {
  public static generateUrl(key: string, params: string[]) {
    // Generate params object
    const paramsObject: UrlParams = {};
    paramsObject.categoryId = this.getParam(params, 'categoryId');
    paramsObject.productId = this.getParam(params, 'productId');
    paramsObject.mspotname = this.getParam(params, 'mspotname');

    let url: string;
    switch (key) {
      case 'ItxCategoryPage':
        url = `c${paramsObject.categoryId}.html`;
        break;
      case 'ItxProductPage':
        url = `c${paramsObject.categoryId}p${paramsObject.productId}.html`;
        break;
      case 'ItxMSpotPage':
        url = `page/${paramsObject.mspotname}.html`;
        break;
      case 'ItxStoreLocatorPage':
        url =  'store-locator.html';
        break;
      case 'ItxGiftCardPage':
        url = 'gift-card.html';
        break;
      case 'ItxAttClientPage':
        url = 'att-client.html';
        break;
      case 'ItxContactPage':
        url = 'contact.html';
        break;
      case 'ItxHomePage':
        url = '';
        break;
      default:
        url = 'not-found-key';
        break;
    }

    return url;
  }

  private static getParam(params: string[], param: string) {
    const matchedParam = params.find(p => {
      const paramSplitted = p.split('=');
      return paramSplitted[0] === param;
    });
    return matchedParam?.split('=')[1];
  }
}
